module.exports = __webpack_public_path__ + "static/2min2mio-3a0473b08bf05822fd6eb570f94eebc8.jpg";